import { PaymentOrigin, PaymentOriginEnum } from '@frontend/api-invoices';
import { WeaveBillPay as OldWeaveBillPayPortal } from '@frontend/payments';
import { useLocationPortal, FailureHandler, SuccessHandler, PaymentsPortal } from '@frontend/payments-portal';
import { PaymentConfigName } from '@frontend/payments-stripe-wrapper';

interface WeaveBillPayProps {
  locationSlug: string;
  amount?: number;
  amountEditable?: boolean;
  showLocationInfo?: boolean;
  paymentConfigName?: PaymentConfigName;
  originType?: PaymentOriginEnum;
  captchaToken?: string | null;
  onSuccess?: SuccessHandler;
  onFailure?: FailureHandler;
}

export const WeaveBillPay = ({
  locationSlug,
  amount,
  amountEditable = true,
  showLocationInfo = true,
  paymentConfigName,
  originType = PaymentOrigin.OnlineBillPay,
  captchaToken = null,
  onSuccess,
  onFailure,
}: WeaveBillPayProps) => {
  const { portalData, newPortalEnabled, refetchPortalData } = useLocationPortal({ locationSlug, onFailure });

  return (
    <PaymentsPortal.VariantSwitch
      primaryVariantEnabled={newPortalEnabled || originType === 'ONLINE_SCHEDULING'}
      primaryVariant={PaymentsPortal.ProcessorSwitch}
      primaryProps={{
        amount,
        amountEditable,
        captchaToken,
        onSuccess,
        onFailure,
        origin: originType,
        paymentConfig: paymentConfigName,
        portalData,
        refetchPortalData,
        showLocationInfo,
      }}
      secondaryVariant={OldWeaveBillPayPortal}
      secondaryProps={{
        locationSlug,
        portalData,
      }}
    />
  );
};
